// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToMedium":"(max-width: 639px)","baseOffset":"0.25rem","desktopOffset":"0.5rem","recipeTileBadge":"Gc075a8"};